
import Vue from 'vue';
import LinkHandler from '@core/components/helpers/LinkHandler.vue';
import getAliasByLocale from '@root/common/utils/getAliasByLocale';

interface Computed {
  links: Array<any>;
}

export default Vue.extend<unknown, unknown, Computed, unknown>({
  components: {
    LinkHandler,
  },
  computed: {
    links() {
      const links: any[] = [];
      const { locale, name } = this.$channelConfig('settings');

      // Get channel link
      links.push({ name, href: '/', position: 1 });

      // Authors link
      const path = getAliasByLocale(locale, 'authors');
      links.push({ name: this.$t('authors.title'), href: `/${path}/`, position: 2 });

      return links;
    },
  },
});
